import {
  Component,
  computed,
  inject,
  signal,
  HostListener,
  ElementRef,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthState } from "../../../../features/auth/services/auth.state";

@Component({
  selector: "app-user-dropdown",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./user-dropdown.component.html",
  styleUrl: "./user-dropdown.component.scss",
})
export class UserDropdownComponent {
  private readonly authState = inject(AuthState);
  private readonly elementRef = inject(ElementRef);

  readonly isOpen = signal(false);

  readonly userInitials = computed(() => {
    const name = this.authState.userName();
    if (!name) return "U";

    const nameParts = name.trim().split(" ");
    if (nameParts.length === 1) {
      return nameParts[0].substring(0, 2).toUpperCase();
    }
    return (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
  });

  readonly userName = computed(() => {
    return this.authState.userName() || "";
  });

  readonly userEmail = computed(() => {
    return this.authState.userEmail();
  });

  readonly userRole = computed(() => {
    const account = this.authState.account();
    return (account?.role as any)?.description ?? "Usuario";
  });

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen.set(false);
    }
  }

  toggleDropdown(): void {
    this.isOpen.update((value) => !value);
  }

  logout(): void {
    this.isOpen.set(false);
    // Add small delay to allow dropdown animation to complete before logout
    setTimeout(() => {
      this.authState.logout();
    }, 200);
  }
}
